import React, { useContext, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { getLineageMetaTitle } from '@/_utils/utils';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../../../_common/ErrorFallback';
import { ConfigContext } from '@/contextAPI/configContext';
import { selectOutputVersions } from '@/redux/selectors/orderPlacementSelectors';
import { getOutputVersionOptions } from '@/redux/slices/orderPlacementSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { TitleEntity } from '@/redux/slices/slice_types';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';
import { OrderPlacementConfig } from '@/__configs/config_types';

interface Props {
  version?: TitleEntity | TitleEntityV2;
  id: string;
}

const OPFileSelectionTitle: React.FC<Props> = ({ version, id }) => {
  const dispatch = useAppDispatch();
  const versionOptionLabel: OrderPlacementConfig['fileSelectionTitle'] = (useContext(ConfigContext) as any)?.orderPlacementConfig?.fileSelectionTitle;
  const outputVersions = useAppSelector(selectOutputVersions);

  useEffect(() => {
    // this is only needed temporarily, to backfill the version options
    // for those drafts that were saved without the version keys
    if (id && !version?.id) {
      const allSelections = outputVersions.reduce((acc: any[], cur) => [...acc, ...(cur as any).selections], []);
      const neededParentId = allSelections?.find((v: any) => v.version_external_id === id)?.parent_id;
      dispatch(getOutputVersionOptions(neededParentId));
    }
  }, []);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {versionOptionLabel ? (
        version ? (
          versionOptionLabel(version)
        ) : null
      ) : (
        <Grid container justifyContent="space-between">
          <strong>{getLineageMetaTitle(version)}</strong>
          <Typography variant="caption" sx={{ mr: 1, color: 'teal.main', opacity: 1 }}>
            {version?.meta?.friendly_name || version?.name} [{id}]
          </Typography>
        </Grid>
      )}
    </ErrorBoundary>
  );
};

export default OPFileSelectionTitle;
